<template>
  <div :class="['dante-menu', $tvaMq, background, { disabled: !active }]">
    <div
      class="dante-menu__desktop-bar"
      :class="{ isOpen: isOpen }"
      v-if="$tvaMq === 'desktop'"
    >
      <div @click="toggleMenu()" class="toggle-button">
        <svgicon
          class="icon-menu"
          icon="icon-menu"
          width="15"
          height="15"
          v-if="!isOpen"
        ></svgicon>
        <svgicon
          class="icon-close"
          icon="icon-close"
          width="15"
          height="15"
          v-else
        ></svgicon>
      </div>
      <div class="logo-container">
        <a href="https://thevisualagency.com/" target="_blank">
          <svgicon
            class="logo-tva"
            icon="logo-tva"
            width="20"
            height="20"
          ></svgicon>
        </a>
      </div>
    </div>
    <div class="dante-menu__mobile-bar" v-if="$tvaMq !== 'desktop'">
      <div
        class="breadcrumb-container"
        v-if="$route.name === 'viz' && !isOpen"
        ref="breadcrumbContainer"
      >
        <div
          class="chip"
          :class="{ active: !getVizElSelected }"
          @click="resetQuery()"
        >
          {{ $ml.get("dataviz").title }}
        </div>
        <div
          class="chip"
          :class="{ active: el.id === getVizElSelected.data.id }"
          v-for="el in breadcrumb"
          :key="el.id"
          @click="setQuery(el.depth, el.id)"
        >
          {{ el.name }}
        </div>
      </div>

      <div @click="toggleMenu()" class="burger">
        <svgicon
          v-if="!isOpen"
          class="icon-menu"
          icon="icon-menu"
          width="18"
          height="18"
        ></svgicon>
        <svgicon
          v-else
          class="icon-close"
          icon="icon-close"
          width="18"
          height="18"
        ></svgicon>
      </div>
    </div>
    <transition name="fade">
      <div v-if="isOpen" class="dante-menu__container">
        <div class="dante-menu__abstract">
          <h1
            v-html="
              $tvaMq !== 'desktop'
                ? content.abstract.titleMobile
                : content.abstract.title
            "
            class="title"
          ></h1>
          <p v-html="content.abstract.abstract" class="paragraph"></p>
          <div class="buttons-container">
            <div
              :class="[
                $tvaMq !== 'desktop'
                  ? 'button--secondary-text-circle'
                  : 'button--secondary-text-square'
              ]"
              v-html="content.abstract.goBackButtoon"
              @click="goTo('landing')"
            ></div>
            <button
              :class="[
                'navigate',
                $tvaMq !== 'desktop'
                  ? 'button--primary-text-circle'
                  : 'button--primary-text-square'
              ]"
              v-html="content.abstract.exploreButton"
              @click="navigateClick()"
            ></button>
          </div>
        </div>
        <div class="dante-menu__column">
          <div
            class="routing-container"
            v-for="(el, i) in config.menu.routing"
            :key="el.path"
            :class="[
              { hasBorder: i < config.menu.routing.length - 1 },
              content.routing[el.idLabel].label
            ]"
          >
            <div class="routing-button" @click="goTo(el.path)">
              {{ content.routing[el.idLabel].label }}
            </div>
          </div>
        </div>
        <div class="dante-menu__control">
          <div
            class="dante-menu__control__section"
            v-for="el in config.menu.controls"
            :key="el.idLabel"
          >
            <div class="label">{{ content.controls[el.idLabel].label }}</div>

            <component
              :is="el.component"
              :config="el"
              :content="content.controls[el.idLabel]"
            />
          </div>
        </div>
      </div>
    </transition>
  </div>
</template>
<script>
import { mapActions, mapGetters } from "vuex";
import config from "@/assets/content/config.json";
import MenuContact from "@/components/components-menu/MenuContact";
import MenuRelated from "@/components/components-menu/MenuRelated";
import MenuCredits from "@/components/components-menu/MenuCredits";
import MenuLanguageSwitch from "@/components/components-menu/MenuLanguageSwitch";
import MenuSocialShare from "@/components/components-menu/MenuSocialShare";
import genericQueryMethods from "@/mixins/genericQueryMethods";
import _ from "lodash";

import "@/compiled-icons/icon-menu";
import "@/compiled-icons/icon-close";
import "@/compiled-icons/logo-tva";

export default {
  props: {
    background: {
      type: String,
      default: "black"
    },
    active: {
      default: true
    }
  },
  data() {
    return {
      isOpen: false,
      config
    };
  },
  components: {
    MenuContact,
    MenuRelated,
    MenuCredits,
    MenuLanguageSwitch,
    MenuSocialShare
  },
  methods: {
    toggleMenu() {
      return (this.isOpen = !this.isOpen);
    },
    goTo(routeName) {
      this.resetQuery();
      this.$router.push({
        name: routeName
      });
      this.isOpen = false;
    },
    navigateClick() {
      this.isOpen = !this.isOpen;
      if (this.$route.name !== "viz") {
        this.goTo("viz");
      }
    }
  },
  computed: {
    content() {
      return this.$ml.get("menu");
    },
    breadcrumb() {
      let breadcrumbArray = [];
      const getInfo = obj => {
        breadcrumbArray.push({
          id: obj.data.id,
          name: obj.data.name,
          depth: obj.depth
        });
        if (obj.parent && obj.depth > 1) {
          getInfo(obj.parent);
        }
      };
      if (this.getVizElSelected) {
        getInfo(this.getVizElSelected);
      }
      return breadcrumbArray.reverse();
    },
    ...mapGetters(["getVizElSelected"])
  },
  watch: {
    breadcrumb() {
      let el = this.$refs.breadcrumbContainer;
      setTimeout(() => {
        let width = el.scrollWidth;

        el.scrollTo({
          top: 0,
          left: width,
          behavior: "smooth"
        });
      });
    }
  },
  mixins: [genericQueryMethods]
};
</script>
<style lang="scss" scoped>
.dante-menu {
  position: fixed;
  background: $black;
  &.gradient {
    background-image: linear-gradient(to bottom, #96c2c3, #bea95e, #573c46);
  }
  &.transparent {
    background: transparent;
    .dante-menu__desktop-bar {
      // border-right: none;
    }
  }
  &.disabled {
    pointer-events: none;
    .dante-menu__desktop-bar {
      opacity: 0;
    }
  }
  &.mobile,
  &.tablet {
    width: 100vw;
    left: 0;
    top: 0;
    z-index: $z-f;
    position: fixed;
  }
  &.desktop {
    height: 100vh;
    left: 0;
    top: 0;
    z-index: $z-e;
  }
  &__abstract {
    width: 100%;
    background-image: linear-gradient(to top, #96c2c3, #bea95e, #573c46);
    .mobile & {
      padding: 0 40px 0 18px;
      display: flex;
      flex-direction: column;
      justify-content: center;
    }
    .tablet & {
      padding: 120px 320px 120px 105px;
      display: flex;
      flex-direction: column;
      justify-content: center;
    }

    .desktop & {
      width: 600px;
      height: 100%;
      padding: 0 120px;
      display: flex;
      flex-direction: column;
      justify-content: center;
    }
    .buttons-container {
      display: flex;
      flex-direction: row;
      justify-content: space-between;
      margin-bottom: $margin-S;
      .button--secondary-text-square {
        margin: $margin-S 0;
      }
      .desktop & {
        flex-direction: column;
      }

      .tablet & {
        justify-content: flex-start;
        .button--primary-text-circle {
          margin-left: $margin-XS;
        }
      }

      .mobile &,
      .tablet & {
        .button--secondary-text-circle {
          color: $white;
          border-color: $white;
        }
      }
    }
    .title {
      .mobile &,
      .tablet & {
        @include HH3;
        margin: 32px 0 20px;
      }
      .desktop & {
        @include HH2;
        margin: 0;
        padding-bottom: $margin-XS;
      }
    }
    .paragraph {
      .mobile &,
      .tablet & {
        @include pS;
        margin: 0;
        padding-bottom: 20px;
      }
      .desktop & {
        @include pM;
      }
    }
  }
  &__column {
    border: 1px dashed black;
    .desktop & {
      width: calc((100% - 600px) * 0.4);
      height: 100%;
    }
    .routing-container {
      flex-grow: 1;
      height: calc(100% / 3);
      display: flex;
      align-items: center;
      &.Tutorial {
        .mobile &,
        .tablet & {
          display: none;
          height: 0;
        }
      }
      .mobile &,
      .tablet & {
        border-bottom: 1px solid $white-50;
      }
      &.hasBorder {
        border-bottom: 1px solid $white-50;
      }
      .routing-button {
        transition: all 0.3s ease;
        @include ButtonM;
        .mobile & {
          margin-left: 16px;
          padding: 45px 0;
        }

        .tablet & {
          margin-left: 105px;
          padding: 30px 0;
        }
        .desktop & {
          @include ButtonL;
          margin-left: 50px;
          padding-bottom: 5px;
          border-bottom: 2px solid $white-70;
          color: $white-70;
          cursor: pointer;
          &:hover {
            color: $white;
            border-bottom: 2px solid $white;
          }
        }
      }
    }
  }
  &__control {
    display: flex;
    flex-direction: column;

    .mobile & {
      justify-content: space-around;
      padding-bottom: 100px;
      margin-top: 20px;
    }

    .tablet & {
      min-height: 300px;
      justify-content: space-around;
    }

    .desktop & {
      width: calc((100% - 600px) * 0.6);
      height: 100%;
      border-left: 1px solid $white-50;
      justify-content: space-around;
      padding-left: 50px;
    }
    &__section {
      display: flex;
      flex-direction: row;
      .mobile &,
      .tablet & {
        flex-direction: row;
        padding-bottom: 18px;
        margin-left: 16px;
        align-items: center;
      }

      .tablet & {
        margin-left: 105px;
      }
      .desktop & {
        flex-direction: column;
      }
      .label {
        .mobile &,
        .tablet & {
          @include overlayM;
          text-transform: uppercase;
          padding-right: 12px;
          color: $white-50;
          // color:red;
        }
        .desktop & {
          @include overlayS;
          text-transform: uppercase;
          padding-bottom: 10px;
        }
      }
    }
  }
  &__desktop-bar {
    height: 100%;
    width: 35px;
    border-right: 1px solid $white;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    .logo-container {
      border-top: 1px solid $white;
      width: 100%;
      height: 35px;
      display: flex;
      align-items: center;
      justify-content: center;
      .logo-tva {
        fill: white;
      }
    }
    .toggle-button {
      border-bottom: 1px solid $white;
      width: 100%;
      height: 35px;
      display: flex;
      align-items: center;
      justify-content: center;
      cursor: pointer;
      .icon-menu {
        fill: $white-70;
        &:hover {
          fill: $white;
        }
      }
      .icon-close {
        fill: $white-70;
        &:hover {
          fill: $white;
        }
      }
    }
    &.isOpen {
      background: black;
    }
  }
  &__mobile-bar {
    height: 40px;
    width: 100%;
    background: black;
    display: flex;
    flex-direction: row;
    .breadcrumb-container {
      display: flex;
      flex-direction: row;
      width: calc(100% - 33px);
      overflow-y: auto;
      align-items: center;
      position: relative;

      &::-webkit-scrollbar {
        display: none;
      }
      &::after {
        content: "";
        position: fixed;
        left: 0;
        top: 0;
        height: 40px;
        width: 25px;
        opacity: 0.6;
        background-image: linear-gradient(to right, $black, rgba(0, 0, 0, 0));
        pointer-events: none;
        z-index: $z-b;
      }
      &::before {
        content: "";
        position: fixed;
        right: 37px;
        top: 0;
        height: 40px;
        width: 25px;
        opacity: 0.6;
        background-image: linear-gradient(to left, $black, rgba(0, 0, 0, 0));
        pointer-events: none;
        z-index: $z-b;
      }
      .chip {
        height: 26px;
        // display: flex;
        // flex-direction: row;
        // justify-content: center;
        // align-items: center;
        padding: 2px 10px;
        border-radius: 30px;
        border: solid 1px $white;
        text-align: center;
        color: $white;
        margin-right: 5px;
        white-space: nowrap;
        @include ButtonS;
        z-index: 1;
        &:first-child {
          margin-left: 22px;
        }
        &.active {
          background-color: $white;
          color: $black;
          pointer-events: none;
        }
      }
    }
    .burger {
      height: 100%;
      width: 40px;
      display: flex;
      align-items: center;
      justify-content: center;
      margin-left: auto;
    }
    .icon-menu {
      fill: $white;
    }
    .icon-close {
      fill: $white;
    }
  }
  &__container {
    height: calc(100vh - 40px);
    width: 100%;
    background: $black;
    color: $white;
    position: absolute;
    left: 0;
    top: 40px;
    display: flex;
    flex-direction: column;
    .mobile &,
    .tablet & {
      overflow-y: auto;
    }
    .desktop & {
      width: calc(100vw - 35px);
      flex-direction: row;
      left: 35px;
      top: 0;
      height: 100vh;
      z-index: $z-g;
    }
  }
}
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}
</style>
